// extracted by mini-css-extract-plugin
export default {"text":"TextMenuItem_text__pJJiC","icon":"TextMenuItem_icon__HkMae"};